import { render, staticRenderFns } from "./MessageTemplateText.vue?vue&type=template&id=ba215776&scoped=true"
import script from "./MessageTemplateText.vue?vue&type=script&lang=ts"
export * from "./MessageTemplateText.vue?vue&type=script&lang=ts"
import style0 from "./MessageTemplateText.vue?vue&type=style&index=0&id=ba215776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba215776",
  null
  
)

export default component.exports